// useLogCheckout.js
import { useState } from "react";
import { useSession } from "../utils/SessionContext";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";

const useLogCheckout = () => {
  const { session_id, vendorUrl, product_id, setShowModal } = useSession();
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const logCheckout = async (product_id_to_log) => {
    const url = "/log_checkout";
    const params = {
      session_id,
      vendor_url: vendorUrl,
      product_id_to_log,
      timestamp: unixTimestamp(),
    };

    try {
      const res = await api.post(url, null, { params });
      setResponse(res.data);
//      setShowModal({ show: false, level: 1 });
    } catch (err) {
      setError(err.response ? err.response.data : { message: err.message });
    }
  };

  return { response, error, logCheckout };
};

export default useLogCheckout;
